import { z } from "zod";

const UNESCAPE_RE: [RegExp, string][] = [
  [/\\t/g, "\t"],
  [/\\n/g, "\n"],
  [/\\r/g, "\r"],
];

function unescapeChar(s: string): string {
  return UNESCAPE_RE.reduce((acc, [re, ch]) => acc.replace(re, ch), s);
}

/**
 * Zod schema for a single-character CSV field (delimiter or quote).
 * Accepts common escape sequences (e.g. "\\t") and converts them to
 * the actual character before enforcing the 1-character length limit.
 */
export const csvCharField = z
  .string()
  .transform(unescapeChar)
  .pipe(z.string().max(1));
